module.exports = __webpack_public_path__ + "static/media/pct.08984333.ttf";